import { useRef, useState } from 'react';

// material-ui
import {
  Box,
  ClickAwayListener,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
  Typography,
} from '@mui/material';

// project import
import useConfig from '../hooks/useConfig';

// assets
import { TranslationOutlined } from '@ant-design/icons';
import Transitions from '../components/@extended/Transitions';
import IconButton from '../components/@extended/IconButton';

const Localization = () => {
  const { i18n, onChangeLocalization } = useConfig();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  // List of supported languages
  const languages = [
    { code: 'th', name: 'ภาษาไทย', short: 'TH' },
    { code: 'vi', name: 'Tiếng Việt', short: 'VI' },
    { code: 'zh', name: '中文', short: 'CN' },
    { code: 'en', name: 'English', short: 'EN' },
  ];

  const handleToggle = () => setOpen((prevOpen) => !prevOpen);

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleListItemClick = (langCode) => {
    onChangeLocalization(langCode);
    setOpen(false);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <IconButton
        color="secondary"
        variant="light"
        sx={{
          color: 'text.primary',
          bgcolor: open ? 'action.selected' : 'transparent',
        }}
        aria-label="open localization"
        ref={anchorRef}
        aria-controls={open ? 'localization-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <TranslationOutlined />
      </IconButton>
      <Popper
        placement="bottom-start"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
            <Paper sx={{ boxShadow: 3 }}>
              <ClickAwayListener onClickAway={handleClose}>
                <List
                  component="nav"
                  sx={{
                    p: 0,
                    width: '100%',
                    minWidth: 200,
                    maxWidth: 290,
                    bgcolor: 'background.paper',
                    borderRadius: 1,
                  }}
                >
                  {languages.map(({ code, name, short }) => (
                    <ListItemButton
                      key={code}
                      selected={i18n === code}
                      onClick={() => handleListItemClick(code)}
                    >
                      <ListItemText
                        primary={
                          <Grid container alignItems="center">
                            <Typography color="textPrimary">{name}</Typography>
                            <Typography
                              variant="caption"
                              color="textSecondary"
                              sx={{ ml: 1 }}
                            >
                              ({short})
                            </Typography>
                          </Grid>
                        }
                      />
                    </ListItemButton>
                  ))}
                </List>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
};

export default Localization;
